export default {
	orderStatus: {
		0: '待支付',
		1: '送检中',
		2: '检测中',
		3: '已完成',
		4: '待送检',
		99: '交易关闭'
	},
	recommendType: {
		1: '自选',
		2: '智能推荐'
	},
	// 样本类型
	detectType: {
		1: '血清',
		2: '脑脊液',
		3: '血浆',
		4: '外周血',
		5: '血清+脑脊液'
	}
}
